export default "__VITE_ASSET__CeVXJix1__"